export const ABOUT_TIMELINE_ID = "about-timeline";
